<template>
  <div>
    <nav class="navbar navbar-expand-lg navbar-dark bg-dark">
      <div class="container-fluid">
        <span class="navbar-brand text-info fs-4 fw-bold me-3">DashBoard App</span>
        <button
          class="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarSupportedContent"
          aria-controls="navbarSupportedContent"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span class="navbar-toggler-icon"></span>
        </button>
        <div class="collapse navbar-collapse" id="navbarSupportedContent">
          <ul class="navbar-nav me-auto mb-2 mb-lg-0">
            <li class="nav-link" v-if="isLoggedIn && isTeacher()">
              <router-link to="/home">Dashboard </router-link>
            </li>
            <li class="nav-link" v-if="isLoggedIn && isTeacher()">
              <router-link to="/add-student">Add Student </router-link>
            </li>
            <li class="nav-link" v-if="isLoggedIn && isTeacher()">
              <router-link to="/add-assignment">Add Assignment </router-link>
            </li>
            <li class="nav-link text-white" v-if="isLoggedIn && isTeacher()">
              <router-link to="/assignment-status"
                >Assignment Status</router-link
              >
            </li>
            <li class="nav-link" v-if="isLoggedIn && isTeacher()">
              <router-link to="/add-notice">Add Notice </router-link>
            </li>
            <li class="nav-link" v-if="isLoggedIn && isTeacher()">
              <router-link to="/profile">View Profile</router-link>
            </li>

            <!-- student links -->
            <li class="nav-link" v-if="isLoggedIn && isStudent()">
              <router-link to="/student-dashboard"
                >Student Dashboard</router-link
              >
            </li>
            <li class="nav-link" v-if="isLoggedIn && isStudent()">
              <router-link to="/view-assignment">View Assignment</router-link>
            </li>
            <li class="nav-link" v-if="isLoggedIn && isStudent()">
              <router-link to="/submitted-assignment"
                >Submitted Assignment</router-link
              >
            </li>
            <li class="nav-link" v-if="isLoggedIn && isStudent()">
              <router-link to="/view-notice">View Notice</router-link>
            </li>
            <li class="nav-link" v-if="isLoggedIn && isStudent()">
              <router-link to="/profile">View Profile</router-link>
            </li>

            <li class="nav-link" v-if="!isLoggedIn">
              <router-link to="/login">Login </router-link>
            </li>
            <li class="nav-link" v-if="!isLoggedIn">
              <router-link to="/register-student">Register</router-link>
            </li>

            <!-- <li
              class="pt-2 pe-2 text-light "
              v-if="isLoggedIn"
            >
              Hi {{ user.username }}
            </li> -->
            <li
              class="nav-link "
              v-if="isLoggedIn"
            >
              <a to="/logout" @click.prevent="logoutUser">Logout</a>
            </li>
          </ul>
        </div>
      </div>
    </nav>

    <!-- bootstrap Sidebar -->
    <!-- <button class="btn btn-primary" type="button" data-bs-toggle="offcanvas" data-bs-target="#offcanvasWithBothOptions" aria-controls="offcanvasWithBothOptions">Menu</button>

<div class="offcanvas offcanvas-start" data-bs-scroll="true" tabindex="-1" id="offcanvasWithBothOptions" aria-labelledby="offcanvasWithBothOptionsLabel">
  <div class="offcanvas-header">
    <button type="button" class="btn btn-primary" data-bs-dismiss="offcanvas" aria-label="Close">Close</button>
  </div>
  <div class="offcanvas-body">
    <p>Try scrolling the rest of the page to see this option in action.</p>
  </div>
</div> -->
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
export default {
  name: "SideNavbar",
  data() {
    return {

    };
  },
  computed: {
    ...mapGetters(["isLoggedIn", "user"]),
    // ...mapGetters(["user"]), //This i have added to get role
  },
  methods: {
    ...mapActions(["logout", "getProfile"]),
    // ...mapActions(["getProfile"]),  //This i have added for role
    logoutUser() {
      this.logout();
    },

    isTeacher(){
      if(localStorage.role=='Teacher'){
        return true
      }
      else{
        return false
      }
    },
    isStudent(){
      if(localStorage.role=='student'){
        return true
      }
      else{
        return false
      }
    }
  },

  created() {
    //This i have added for role
    // this.getProfile();
        // this.isTeacher();
        // this.isStudent();
  },
      beforeUpdate(){
        this.getProfile();

      }
};
</script>

<style scoped>

.nav-link>a{
  color:white;
  text-decoration: none;
}
.nav-link>a:hover{
  color: #0DCAF0;

}
a.router-link-active{
  font-weight: 600;
color: #0DCAF0;
    }



.nav li {
  list-style-type: none;
  text-align: center;
  padding: 10px 10px;
  font-size: 20px;
}
.nav li > a {
  color: #000;
  text-decoration: none;
}
.nav li > a:hover {
  /* background-color:rgb(197, 217, 210); */
  /* padding:10px 50px; */
  color: red;
  text-decoration: none;
}

.nav ul {
  padding-left: 0;
}
</style>